import {packageId} from '@/config';
import * as baseVariable from '@components/style/base.variable';

// // 为了方便后期更换方案时整理,这个文件暂时统一在master维护,做条件判断

switch (packageId) {
  case 2:
    // bhau
    baseVariable.fontColor.main = '#121410';
    baseVariable.fontColor.second = '#48505D';
    baseVariable.fontColor.accent = '#8D97AB';
    baseVariable.basicColor.primary = '#00B512';
    baseVariable.basicColor.red = '#D64D00';
    baseVariable.backgroundColor.main = '#00B512';
    baseVariable.basicColor.primaryLinearGradient = ['#00B512', '#00910E'];
    baseVariable.basicColor.proxyLinearGradient = [
      'rgba(0, 134, 70, 0.00)',
      '#00562D',
    ];
    baseVariable.basicColor.proxybgColor = '#008646';
    baseVariable.basicColor.proxyResetLink = '#DDFFE1';
    baseVariable.basicColor.proxylightLinear = ['#00C07B', '#00DA30'];
    baseVariable.basicColor.loginLinearGradient = ['#E8FFEB', '#FFF'];
    baseVariable.basicColor.rechargeButtonLinearGradient = [
      '#00B512',
      '#00B512',
    ];
    baseVariable.basicColor.invitationRecordLinearGradient = [
      '#CBFBD8',
      'rgba(255, 255, 255, 0.00)',
    ];
    baseVariable.basicColor.invitationRuleColors = {
      tableHeader: '#0C961A',
      tableEven: '#D4F8D6',
      tableOdd: '#E6FDE7',
    };
    baseVariable.backgroundColor.lightGrey = '#F4F5F8';
    baseVariable.backgroundColor.sattaDigitShadow = '#00F51880';
    break;
  case 3:
    // singam
    baseVariable.backgroundColor.timeLinearGradient = ['#DCD1FC', '#E6D7FF'];
    baseVariable.backgroundColor.remainingLinearGradient = [
      '#D6CAFA',
      '#E6D6FF',
    ];
    baseVariable.backgroundColor.ruleBtn = '#EBE2FF';
    baseVariable.backgroundColor.diceResultBg = '#B098D8';
    baseVariable.backgroundColor.diceResultBgLight = '#D6C6F1';
    baseVariable.backgroundColor.rateItem = '#F6E9FF';
    baseVariable.backgroundColor.colorQuickLinearGradient = [
      '#DACEED',
      '#D4C8E9',
    ];
    baseVariable.backgroundColor.colorBall = '#C2B6D5';
    baseVariable.backgroundColor.colorBets = '#ADA4BC';
    baseVariable.backgroundColor.colorBetsListBg = '#746D80';
    baseVariable.backgroundColor.colorBetsListBgLight = '#958BA6';
    baseVariable.backgroundColor.colorBetsDotBg = '#6B6477';
    baseVariable.fontColor.colorMyBets = '#374046';
    baseVariable.basicColor.darkPrimary = '#6F00B4';
    baseVariable.backgroundColor.colorDashed = '#897AA1';
    break;
  case 5:
    // 99
    // baseVariable.basicColor.primary = '#D90000';
    baseVariable.basicColor.primary = '#821062';
    baseVariable.basicColor.red = '#FF382C';
    // baseVariable.basicColor.primaryLinearGradient = ['#DB0000', '#AB0000'];
    baseVariable.basicColor.primaryLinearGradient = [
      baseVariable.basicColor.primary,
      baseVariable.basicColor.primary,
    ];
    baseVariable.backgroundColor.meTopGradient =
      baseVariable.basicColor.primaryLinearGradient;
    baseVariable.basicColor.proxybgColor = baseVariable.basicColor.primary;
    baseVariable.basicColor.proxyLinearGradient = [
      baseVariable.basicColor.primary,
      baseVariable.basicColor.primary,
    ];
    baseVariable.basicColor.proxyRebate = baseVariable.basicColor.primary;
    baseVariable.basicColor.invitationRuleColors.tableHeader =
      baseVariable.basicColor.primary;
    baseVariable.basicColor.invitationRuleColors.tableOdd =
      'rgba(130, 16, 98, 0.1)';
    baseVariable.basicColor.invitationRuleColors.tableEven =
      'rgba(130, 16, 98, 0.3)';

    baseVariable.fontColor.main = '#252529';
    baseVariable.fontColor.second = '#45454d';
    baseVariable.fontColor.accent = '#848490';
    baseVariable.fontColor.secAccent = '#bbbbc5';
    baseVariable.backgroundColor.main = baseVariable.basicColor.primary;
    baseVariable.backgroundColor.second = '#3988FD';
    baseVariable.backgroundColor.accent = '#FF7E2B';
    baseVariable.backgroundColor.secAccent = '#FFB21E';
    baseVariable.backgroundColor.grey = '#dcdce5';
    baseVariable.backgroundColor.palegrey = '#DEE2E8';
    baseVariable.backgroundColor.lightGrey = '#F6F7FA';
    baseVariable.invitationBaseColors.signGiftBgColor = '#F16626';
    baseVariable.invitationBaseColors.registSuccess = '#009B22';
    baseVariable.backgroundColor.timeLinearGradient = ['#FCD1D1', '#FFFFFF'];
    baseVariable.backgroundColor.remainingLinearGradient = [
      '#FFD9D9',
      '#FFF0F0',
    ];
    baseVariable.backgroundColor.ruleBtn = '#FFEBEB';
    baseVariable.backgroundColor.diceResultBg = '#D89898';
    baseVariable.backgroundColor.diceResultBgLight = '#FFC5C5';
    baseVariable.backgroundColor.rateItem = '#F6E9FF';
    baseVariable.backgroundColor.colorQuickLinearGradient = [
      '#FFDBDB',
      '#FFEAEA',
    ];
    baseVariable.backgroundColor.colorBall = '#D5B6B6';
    baseVariable.backgroundColor.colorBets = '#BCA4A4';
    baseVariable.backgroundColor.colorBetsListBg = '#806D6D';
    baseVariable.backgroundColor.colorBetsListBgLight = '#A68B8B';
    baseVariable.backgroundColor.colorBetsDotBg = '#776464';
    baseVariable.fontColor.colorMyBets = '#463737';
    baseVariable.basicColor.darkPrimary = '#630C4A';
    baseVariable.backgroundColor.colorDashed = '#897AA1';
    // baseVariable.backgroundColor.betsBgDark = '#CD0000';
    baseVariable.backgroundColor.betsBgDark = baseVariable.basicColor.primary;
    baseVariable.backgroundColor.betsBgLight = '#FFF0F0';
    break;
  case 10:
    // 99
    // baseVariable.basicColor.primary = '#D90000';
    baseVariable.basicColor.primary = '#00AA96';
    baseVariable.basicColor.red = '#FF382C';
    baseVariable.basicColor.primaryLinearGradient1 = ['#2DB1A2', '#00DFC5'];
    baseVariable.basicColor.primaryLinearGradient = [
      baseVariable.basicColor.primary2,
      baseVariable.basicColor.primary2,
    ];
    baseVariable.backgroundColor.meTopGradient = ['#000', '#000'];
    baseVariable.basicColor.proxybgColor = baseVariable.basicColor.primary;
    baseVariable.basicColor.proxyLinearGradient = [
      baseVariable.basicColor.primary,
      baseVariable.basicColor.primary,
    ];
    baseVariable.basicColor.proxyLinearGradient1 = [
      'rgba(0, 134, 118, 0.00)',
      '#037769',
    ];
    // baseVariable.basicColor.proxyLinearGradient = [
    //   '#00DFC5',
    //   '#00DFC5',
    // ];
    baseVariable.basicColor.proxyRebate = baseVariable.basicColor.primary;
    baseVariable.basicColor.invitationRuleColors.tableHeader =
      baseVariable.basicColor.primary;
    baseVariable.basicColor.invitationRuleColors.tableOdd = '#E6FDFA';
    baseVariable.basicColor.invitationRuleColors.tableEven = '#D4F8F4';

    baseVariable.fontColor.main = '#252529';
    baseVariable.fontColor.second = '#45454d';
    baseVariable.fontColor.accent = '#5F6975';
    // baseVariable.fontColor.accent = 'rgba(255,255,255,.7)';
    baseVariable.fontColor.white = '#fff';
    baseVariable.fontColor.secAccent = '#bbbbc5';
    baseVariable.backgroundColor.main = baseVariable.basicColor.primary;
    baseVariable.backgroundColor.second = '#3988FD';
    // baseVariable.backgroundColor.accent = '#FF7E2B';
    baseVariable.backgroundColor.accent = '#FFF';
    baseVariable.backgroundColor.secAccent = '#FFB21E';
    baseVariable.backgroundColor.grey = '#dcdce5';
    baseVariable.backgroundColor.palegrey = '#DEE2E8';
    baseVariable.backgroundColor.lightGrey = '#F5F4F1';
    baseVariable.backgroundColor.headerBG = '#00DFC5';
    baseVariable.invitationBaseColors.signGiftBgColor = '#F16626';
    baseVariable.invitationBaseColors.registSuccess = '#009B22';
    baseVariable.backgroundColor.timeLinearGradient = ['#FCD1D1', '#FFFFFF'];
    baseVariable.backgroundColor.remainingLinearGradient = [
      '#FFD9D9',
      '#FFF0F0',
    ];
    baseVariable.backgroundColor.ruleBtn = '#FFEBEB';
    baseVariable.backgroundColor.diceResultBg = '#D89898';
    baseVariable.backgroundColor.diceResultBgLight = '#FFC5C5';
    baseVariable.backgroundColor.rateItem = '#F6E9FF';
    baseVariable.backgroundColor.colorQuickLinearGradient = [
      '#FFDBDB',
      '#FFEAEA',
    ];
    baseVariable.backgroundColor.colorBall = '#D5B6B6';
    baseVariable.backgroundColor.colorBets = '#BCA4A4';
    baseVariable.backgroundColor.colorBetsListBg = '#806D6D';
    baseVariable.backgroundColor.colorBetsListBgLight = '#A68B8B';
    baseVariable.backgroundColor.colorBetsDotBg = '#776464';
    baseVariable.fontColor.colorMyBets = '#463737';
    baseVariable.basicColor.darkPrimary = '#630C4A';
    baseVariable.basicColor.darkPrimary_1 = '#038A78';
    baseVariable.backgroundColor.colorDashed = '#897AA1';
    // baseVariable.backgroundColor.betsBgDark = '#CD0000';
    baseVariable.backgroundColor.betsBgDark = baseVariable.basicColor.primary;
    baseVariable.backgroundColor.betsBgLight = '#FFF0F0';
    baseVariable.backgroundColor.vipProgressBg = '#A8BCC1';
    baseVariable.basicColor.loginLinearGradient = ['#D5FFFA', '#FFF'];
    baseVariable.basicColor.invitationBtnLinearGradient = ['FFD284', 'FFF9CF'];
    baseVariable.basicColor.invitationRecordLinearGradient = [
      '#DEFFFD',
      'rgba(222, 255, 253, 0.00)',
    ];
    break;
}

export default baseVariable;
